import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";

import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import TrustSection from "./components/TrustSection";
import PhilosophySection from "./components/PhilosophySection";
import ProcessSteps from "./components/ProcessSteps";
import SmartSearch from "./components/SmartSearch";
import ROICalculator from "./components/ROICalculator";
import DocumentScreener from "./components/DocumentScreener";
import ArticlesSection from "./components/ArticlesSection";
import SocialProof from "./components/SocialProof";
import FinalCTA from "./components/FinalCTA";
import PortalCTA from "./components/PortalCTA";
import WhatsAppButton from "./components/WhatsAppButton";
import MobileStickyCTA from "./components/MobileStickyCTA";
import Footer from "./components/Footer";
import Dashboard from "./components/Dashboard";
import AdminDashboard from "./components/AdminDashboard";
import AuthCallback from "./components/AuthCallback";
import LoginPage from "./components/LoginPage";
import ArticleDetail from "./components/ArticleDetail";

function LandingPage() {
    return (
        <div className="bg-white">
            <Navbar />
            <HeroSection />
            <TrustSection />
            <PhilosophySection />
            <ProcessSteps />
            <SmartSearch />
            <ROICalculator />
            <DocumentScreener />
            <ArticlesSection />
            <SocialProof />
            <PortalCTA />
            <FinalCTA />
            <Footer />
            <WhatsAppButton />
            <MobileStickyCTA />
        </div>
    );
}

function AppRouter() {
    const location = useLocation();
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/artikel/:slug" element={<ArticleDetail />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AppRouter />
                <Toaster position="top-center" richColors />
            </BrowserRouter>
        </div>
    );
}

export default App;
